interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`}>
      {eyebrow ? (
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-900">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
          {eyebrow}
        </span>
      ) : null}
      <h2 className="mt-4 text-2xl font-semibold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}